import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


import * as Sentry from '@sentry/browser';

const contrataciones = {
	state: {
		provincias: '',
		user: '',
		cups: '',
		precios: null,
		preciosempresa : null,
		historico: '',
		showbannerllamada: false,
		isEmpresa: false
	},
	getters: {
		getProvincias: (state) => {
			if (!!state.provincias) {
				return state.provincias;
			}
		},
		getUser: state => state.user,
		getCUPS: state => state.cups,
		getPrecios: state => state.precios,
		getHistorico: state => state.historico,
		getshowbannerllamada : state => state.showbannerllamada,
		getPrecioEmpresa: state => state.preciosempresa,
		getIsEmpresa: state => state.isEmpresa
/* 		getTarifasLuz: state => Object.keys(state.precios.tarifas_luz),
		getTarifasGas: state => Object.keys(state.precios.tarifas_gas) */
	},
	actions: {
		requestIsEmpresa: ({ commit }, data) => {
			commit("setIsEmpresa", data);
		},
		sendCUPS: ({ commit, dispatch }, data) => {

			let types = {
				"electric": 'electric',
				"gas": 'gas'
			};

			return new Promise((resolve, reject) => {
				axios.get(`api/cups/${types[data.type]}?cups=` + data.cups).then(result => {
					(result.data.status) ? resolve(result.data) : resolve(result.data);
				}).catch(error => {
					reject(false);
					dispatch('sendErrorToSlack', 'Error en el servicio de CUPS')
				});
			});
		},
		requestProvincias: ({ commit }) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/provincias`)
					.then(response => {
						commit('setProvincias', response.data);
						resolve(true);
					})
					.catch(error => reject(error));
			});
		},
		requestLlamada: ({ }, data) => {

			return new Promise((resolve, reject) => {
				axios.post(`api/tellamamos`, data)
					.then(response => {
						resolve(true);
					})
					.catch(error => reject(error));
			});
		},
		requestUsuario: ({ commit }, data) => {
			return new Promise((resolve, reject) => {
				axios.post(`api/user/create`, data)
					.then(response => {
						resolve(response.data);
						commit('setUser', data)
					})
					.catch(error => reject(error));
			});
		},
		createContrato: ({ }, data) => {
			data.datosinstalacion.tipotarifa = -1;
			return new Promise((resolve, reject) => {
				axios.post(`api/contrato/create`, data)
					.then(response => {
						resolve(response.data);
					})
					.catch(error => reject(error));
			});
		},
		getContrato: ({ }, token) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/getpdf?sign_token=${token}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(error => reject(error));
			});
		},
		sendFirma: ({ getters }, firma) => {

			let data = {
				'firma': firma.src,
				'sign_token': firma.token,
				'boton': firma.boton,
			};

			return new Promise((resolve, reject) => {
				axios.post(`api/ponfirma`, data)
					.then(response => {
						if (response.data.status == true) {
							resolve(true);
						} else {
							resolve(response.data.error_code)
						}
					})
					.catch(error => reject(error));
			});
		},
		requestPrecioCoste: ({ }) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/graph`)
					.then(response => {
						if (response.status == 200) {
							resolve(response.data)
						}
					})
					.catch(error => reject(error));
			});
		},
		requestDataSimulador: ({ }) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/simulator/parts`)
					.then(response => {
						if (response.status == 200) {
							resolve(response.data);
						}
					})
					.catch(error => reject(error));
			});
		},
		requestStreets: ({ }, data) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/street?text=${data.street}&cp=${data.cp}`)
					.then(response => {
						resolve(response.data);
					})
					.catch(error => reject(error));
			});
		},
		checkCUPSsimulador: ({ }, cups) => {
			return new Promise((resolve, reject) => {
				axios.get('api/cups?use=sim&cups=' + cups)
					.then(response => {
						if (!!!response.data.error_code) {
							resolve(response.data);
						} else {
							reject(response.data.error_code);
						}
					})
					.catch(error => reject(error));
			});
		},
		checkCUPSsimulador: ({ }, cups) => {
			return new Promise((resolve, reject) => {
				axios.get('api/cups?use=sim&cups=' + cups)
					.then(response => {
						if (!!!response.data.error_code) {
							resolve(response.data);
						} else {
							reject(response.data.error_code);
						}
					})
					.catch(error => reject(error));
			});
		},
		checkPromo: ({ }, idpromo) => {
			return new Promise((resolve, reject) => {
				axios.get('api/promo/check?promo_code='+idpromo)
					.then(response => {
						resolve(response.data)
					})
					.catch(error => reject(error));

			

			});
		},
		checkAmigo: ({ }, idpromo) => {
			return new Promise((resolve, reject) => {
				axios.get('api/friend/check?friend_token='+idpromo)
					.then(response => {
						resolve(response.data.status)
					})
					.catch(error => reject(error));

			

			});
		},
		sendDataSimulacion: ({ dispatch }, data) => {


			//REPLACE COMA X PUNTO

			let conflicts = ['pago', 'preciocuotafija', 'precioenergia', 'preciopotencia', 'preciopunta', 'preciovalle'];


			conflicts.forEach(e => {
				if (!!data[e]) {
					data[e] = data[e].replace(',', '.');
					data[e] = data[e].replace('€', '');
				}
			});

			return new Promise((resolve, reject) => {
				axios.post(`api/simulator/create`, data)
					.then(response => {
						if (!!response.data.sim_id) {
							resolve(response.data);
						} else {

							Sentry.withScope(function (scope) {
								scope.setExtra("data", data);
								scope.setUser({ "id": data.cups });
								Sentry.captureException(response.data);
							});


							reject(response.data.error_code);
						}
					})
					.catch(error => Sentry.captureException(error));
			});
		},
		sendPersonalesSimulacion: ({ }, data) => {
			return new Promise((resolve, reject) => {
				axios.post(`api/simulator/personal`, data)
					.then(response => {
						if (response.status == 200) {
							resolve(response.data);
						}
					})
					.catch(error => reject(error));
			});
		},
		sendSetCups: ({ commit }, cups) => {
			commit('setCups', cups);
		},
		requestPrecios: ({ commit, state }) => {
			if (state.precios !== null) {
        		return;
      		}
			return new Promise((resolve, reject) => {
        		axios.get("api/prices")
          		.then(response => {
					commit("setPrecios", response.data);
          		})
          		.catch(error => {
            		dispatch("sendErrorToSlack", "Error en el servicio de PRECIOS");
          		});
      		});
		},
		requestHistorico:({commit}) => {

			return new Promise((resolve, reject) => {
				axios.get('api/historic')
				.then(response => {
					resolve(response.data)
				})
				.catch(error => {
					resolve(false);
				});
			});

			
		},
		requestPreciosEmpresa: ({ commit, state }) => {
			if (state.preciosempresa !== null) {
        		return;
      		}
			return new Promise((resolve, reject) => {
				axios.get('api/prices/six_zero')
				.then(response => {
					commit('setPreciosEmpresa', response.data);
				})
				.catch(error => {
					resolve(false);
				});
			});	
		},
		setStatusBannerLlamada({commit}, status){
			commit('setbannerstatus', status)
		}
	},
	mutations: {
		setIsEmpresa(state, isEmpresa) {
			state.isEmpresa = isEmpresa
		},
		setProvincias(state, provincias) {
			state.provincias = provincias;
		},
		setUser(state, user) {
			state.user = user;
		},
		setCups(state, cups) {
			state.cups = cups;
		},
		setIP(state, ip) {
			state.ip = ip;
		},
		setPrecios(state, precios) {
			state.precios = precios;
		},
		setHistorico(state, historico) {
			state.historico = historico;
		},
		setbannerstatus(state, status){
			state.showbannerllamada = status;
		},
		setPreciosEmpresa(state, data){
			state.preciosempresa = data;
		}
	}
}

export default contrataciones;


// WEBPACK FOOTER //
// ./src/store/contratacion.js